module.exports = __webpack_public_path__ + "static/planeta_nosotras-ee2789f818ec1ebc5829a63128430bc5.png";